import { formatDate } from '@/app/utils/formatDate';
import type { RoleRecord } from '../types/roles.types';

const DETAIL_ROW_CLASSES = 'border-b border-mp-border';
const DETAIL_HEADER_CLASSES = 'px-3 py-2 text-left';
const DETAIL_CELL_CLASSES = 'px-3 py-2 text-left';

interface Props {
  role: RoleRecord;
}

export function RoleIdentityPanel({ role }: Props) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm max-w-2xl">
        <tbody>
          <tr className={DETAIL_ROW_CLASSES}>
            <th className={`${DETAIL_HEADER_CLASSES} w-40`}>ID</th>
            <td className={`${DETAIL_CELL_CLASSES} font-mono text-xs`}>{role.id}</td>
          </tr>
          <tr className={DETAIL_ROW_CLASSES}>
            <th className={DETAIL_HEADER_CLASSES}>Name</th>
            <td className={`${DETAIL_CELL_CLASSES} font-mono text-sm`}>{role.name}</td>
          </tr>
          <tr className={DETAIL_ROW_CLASSES}>
            <th className={DETAIL_HEADER_CLASSES}>Display name</th>
            <td className={DETAIL_CELL_CLASSES}>{role.display_name ?? '—'}</td>
          </tr>
          <tr className={DETAIL_ROW_CLASSES}>
            <th className={DETAIL_HEADER_CLASSES}>Description</th>
            <td className={DETAIL_CELL_CLASSES}>{role.description ?? '—'}</td>
          </tr>
          <tr className={DETAIL_ROW_CLASSES}>
            <th className={DETAIL_HEADER_CLASSES}>Created</th>
            <td className={DETAIL_CELL_CLASSES}>{formatDate(role.created_at)}</td>
          </tr>
          <tr className={DETAIL_ROW_CLASSES}>
            <th className={DETAIL_HEADER_CLASSES}>Updated</th>
            <td className={DETAIL_CELL_CLASSES}>{formatDate(role.updated_at)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
